import { useRouter } from 'vue-router'

/**
 * 返回上一页的通用 hook
 * @param fallbackRoute 当没有历史记录时的默认路由，默认为首页 '/'
 */
export function useGoBack(fallbackRoute: string = '/') {
  const router = useRouter()

  /**
   * 返回上一页，如果没有历史记录则跳转到默认路由
   */
  const goBack = () => {
    if (window.history.length > 1) {
      router.back()
    } else {
      router.push(fallbackRoute)
    }
  }

  return {
    goBack,
  }
}
